/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.config.js > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/


import { createApp } from 'vue'







import '@quasar/extras/roboto-font/roboto-font.css'

import '@quasar/extras/fontawesome-v5/fontawesome-v5.css'




// We load Quasar stylesheet file
import 'quasar/dist/quasar.sass'




import 'src/css/app.scss'

import 'vue-tel-input/vue-tel-input.css'

import '@quasar/quasar-ui-qcalendar/src/index.sass'


import createQuasarApp from './app.js'
import quasarUserOptions from './quasar-user-options.js'







const publicPath = `/`


async function start ({
  app,
  router
  , store, storeKey
}, bootFiles) {
  

  
  let hasRedirected = false
  const getRedirectUrl = url => {
    try { return router.resolve(url).href }
    catch (err) {}

    return Object(url) === url
      ? null
      : url
  }
  const redirect = url => {
    hasRedirected = true

    if (typeof url === 'string' && /^https?:\/\//.test(url)) {
      window.location.href = url
      return
    }

    const href = getRedirectUrl(url)

    // continue if we didn't fail to resolve the url
    if (href !== null) {
      window.location.href = href
      
    }
  }

  const urlPath = window.location.href.replace(window.location.origin, '')

  for (let i = 0; hasRedirected === false && i < bootFiles.length; i++) {
    try {
      await bootFiles[i]({
        app,
        router,
        store,
        ssrContext: null,
        redirect,
        urlPath,
        publicPath
      })
    }
    catch (err) {
      if (err && err.url) {
        redirect(err.url)
        return
      }

      console.error('[Quasar] boot error:', err)
      return
    }
  }

  if (hasRedirected === true) {
    return
  }
  

  app.use(router)
  app.use(store, storeKey)

  

    

    
      app.mount('#q-app')
    

    

  

}

createQuasarApp(createApp, quasarUserOptions)

  .then(app => {
    // eventually remove this when Cordova/Capacitor/Electron support becomes old
    const [ method, mapFn ] = Promise.allSettled !== void 0
      ? [
        'allSettled',
        bootFiles => bootFiles.map(result => {
          if (result.status === 'rejected') {
            console.error('[Quasar] boot error:', result.reason)
            return
          }
          return result.value.default
        })
      ]
      : [
        'all',
        bootFiles => bootFiles.map(entry => entry.default)
      ]

    return Promise[ method ]([
      
      import(/* webpackMode: "eager" */ 'boot/activity-name'),
      
      import(/* webpackMode: "eager" */ 'boot/activity-type'),
      
      import(/* webpackMode: "eager" */ 'boot/app-redirect'),
      
      import(/* webpackMode: "eager" */ 'boot/axios'),
      
      import(/* webpackMode: "eager" */ 'boot/customerio'),
      
      import(/* webpackMode: "eager" */ 'boot/insider'),
      
      import(/* webpackMode: "eager" */ 'boot/date-util'),
      
      import(/* webpackMode: "eager" */ 'boot/download-file'),
      
      import(/* webpackMode: "eager" */ 'boot/drag-drop-touch'),
      
      import(/* webpackMode: "eager" */ 'boot/extension-icon'),
      
      import(/* webpackMode: "eager" */ 'boot/firebase'),
      
      import(/* webpackMode: "eager" */ 'boot/fontawesome'),
      
      import(/* webpackMode: "eager" */ 'boot/has-ranking'),
      
      import(/* webpackMode: "eager" */ 'boot/has-score'),
      
      import(/* webpackMode: "eager" */ 'boot/intel-wa-local'),
      
      import(/* webpackMode: "eager" */ 'boot/is-invalid-numstring'),
      
      import(/* webpackMode: "eager" */ 'boot/jitsi'),
      
      import(/* webpackMode: "eager" */ 'boot/lottie-player'),
      
      import(/* webpackMode: "eager" */ 'boot/mask'),
      
      import(/* webpackMode: "eager" */ 'boot/mime-types'),
      
      import(/* webpackMode: "eager" */ 'boot/mitt'),
      
      import(/* webpackMode: "eager" */ 'boot/push-notifications'),
      
      import(/* webpackMode: "eager" */ 'boot/qrcode-reader'),
      
      import(/* webpackMode: "eager" */ 'boot/qs'),
      
      import(/* webpackMode: "eager" */ 'boot/remove-url-signature'),
      
      import(/* webpackMode: "eager" */ 'boot/slugify'),
      
      import(/* webpackMode: "eager" */ 'boot/truncate-links'),
      
      import(/* webpackMode: "eager" */ 'boot/vue-countdown'),
      
      import(/* webpackMode: "eager" */ 'boot/vue-gtag'),
      
      import(/* webpackMode: "eager" */ 'boot/vue-gtm'),
      
      import(/* webpackMode: "eager" */ 'boot/vue-i18n'),
      
      import(/* webpackMode: "eager" */ 'boot/vue-ics'),
      
      import(/* webpackMode: "eager" */ 'boot/vue-long-click'),
      
      import(/* webpackMode: "eager" */ 'boot/vue-marquee-text-component'),
      
      import(/* webpackMode: "eager" */ 'boot/vue-plyr'),
      
      import(/* webpackMode: "eager" */ 'boot/vue-recaptcha-v2'),
      
      import(/* webpackMode: "eager" */ 'boot/vue-google-login'),
      
      import(/* webpackMode: "eager" */ 'boot/vue-scrollto'),
      
      import(/* webpackMode: "eager" */ 'boot/vue-social-sharing'),
      
      import(/* webpackMode: "eager" */ 'boot/vue-tel-input'),
      
      import(/* webpackMode: "eager" */ 'boot/vue-zoomer'),
      
      import(/* webpackMode: "eager" */ 'boot/vuelidate'),
      
      import(/* webpackMode: "eager" */ 'boot/clean-filter'),
      
      import(/* webpackMode: "eager" */ 'boot/show-search'),
      
      import(/* webpackMode: "eager" */ 'boot/language-helper'),
      
      import(/* webpackMode: "eager" */ 'boot/capacitor-listeners'),
      
      import(/* webpackMode: "eager" */ '@quasar/quasar-app-extension-qcalendar/src/boot/register.js')
      
    ]).then(bootFiles => {
      const boot = mapFn(bootFiles).filter(entry => typeof entry === 'function')
      start(app, boot)
    })
  })

